import { styled } from 'theme';

export const StyledCopyButtonWrapper = styled('div')`
  display: inline-block;
`;
